<template>
    <div>
        <el-dialog
            title="上传项目合同"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="800px">
            <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="120px">
                <el-form-item label="项目合同" prop="contractFiles">
                    <!-- <el-button type="primary"  @click="checkDeviceCode">点击上传</el-button> -->
                    <multi-file-choose 
                        ref="uploadDev"
                        :accept="'.pdf'" 
                        :readonlyName="'项目合同_'" 
                        placeholder="只能选择.pdf文件" 
                        :taxFiles.sync='form.contractFiles' :max="1"></multi-file-choose>
                </el-form-item>
                <el-form-item label="开始日期" prop="startDate">
                    <el-date-picker 
                        v-model="form.startDate" 
                        type="date" 
                        value-format="yyyy-MM-dd" 
                        format="yyyy-MM-dd" 
                        placeholder="请选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" prop="endDate">
                    <el-date-picker 
                        v-model="form.endDate" 
                        type="date" 
                        value-format="yyyy-MM-dd" 
                        format="yyyy-MM-dd" 
                        placeholder="请选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="合同说明" prop="contractNote">
                    <el-input
                        style="width: 400px;"
                        type="textarea"
                        :autosize="{ minRows: 4 }"
                        placeholder="请输入内容"
                        maxlength="200"
                        show-word-limit
                        v-model="form.contractNote">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
    import multiFileChoose from '../../components/formcy/multi-file-choose.vue';
    export default {
        components:{
            multiFileChoose
        },
        data() {
            // var checkStartDate = (rule, value, callback) => {
            //     if(value){
            //         if(!this.incomeEndTime) {
            //             callback()
            //         }else {
            //             if(this.$getDay.getTimeUnix(value) < this.$getDay.getTimeUnix(this.incomeEndTime)) {
            //                 callback(new Error('开始日期须大于项目当前到期日期'))
            //             }else {
            //                 callback()
            //             }
            //         }
            //     }else {
            //         callback(new Error('请选择开始日期'))
            //     }
            // };
            var checkEndDate = (rule, value, callback) => {
                if(!value) {
                    callback(new Error('请选择结束日期'))
                }else {
                    if(this.$getDay.getTimeUnix(value) < this.$getDay.getTimeUnix(this.form.startDate)) {
                        callback(new Error('结束日期须大于开始日期'))
                    }else {
                        callback()
                    }
                }
            };
            return {
                dialogVisible: false,
                id: '',
                incomeId: '',
                incomeEndTime: '',
                form: {
                    contractFiles: '',
                    contractNote: '',
                    startDate: '',
                    endDate: '',
                },
                rules: {
					// contractFiles: [{required: true, message:'请上传项目合同', trigger: 'change'}],
					startDate: [{required: true, message:'请选择开始日期', trigger: 'change'}],
					endDate: [{required: true, message:'请选择结束日期', trigger: 'change'},{ validator: checkEndDate, trigger: 'change' }],
                },
            };
        },
        props: {
            type: {
                default: 'add'
            },
            defaultData: {
                default: ''
            }
        },
        watch:{
            dialogVisible (val) {
                if(!val) {
                    if(this.$refs['form']){
                        this.form = {
                            contractFiles: '',
                        }
                        this.$refs['uploadDev'].fileList = []
                        this.$refs['form'].resetFields()
                    }
                }else {
                    if(this.defaultData) {
                        this.form = {
                            contractFiles: this.defaultData.contractFile ? [{ url: this.defaultData.contractFile, name: this.defaultData.contractFile }] : '',
                            contractNote: this.defaultData.contractNote,
                            startDate: this.defaultData.startDate,
                            endDate: this.defaultData.endDate,
                        }
                        this.$nextTick(()=>{
                            if(this.defaultData.contractFile) {
                                this.$refs['uploadDev'].fileList = [{ url: this.defaultData.contractFile, name: this.defaultData.contractFile }]
                            }
                           
                        })
                    }
                }
                
            },
        },
        methods:{
            // /**
			//  * 获取项目详情
			//  */
			// getIncomeDetail() {
			// 	this.$Axios._get({
            //         url: this.$Config.apiUrl.gitEditIncomeDetailInfo,
            //         showLoading: true,
            //         params: {
            //             incomeId: this.id,
            //         },
            //     })
            //     .then(({
            //         data
            //     }) => {
            //         if(data.contractFile) {
            //             this.$refs['uploadDev'].fileList = [{
            //                 name: data.contractFile,
            //                 url: data.contractFile
            //             }]
            //         }
            //     });
			// },
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$confirm('是否确认上传项目合同？', '温馨提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(_=>{
                            let reqData
                            if(this.type == 'add') {
                                reqData = {
                                    incomeId: this.incomeId,
                                    contractFile: this.form.contractFiles.length ? this.form.contractFiles[0].url : '',
                                    contractNote: this.form.contractNote,
                                    startDate: this.form.startDate,
                                    endDate: this.form.endDate,
                                }
                            }else if(this.type == 'update'){
                                reqData = {
                                    id: this.id,
                                    incomeId: this.incomeId,
                                    contractFile:  this.form.contractFiles.length ? this.form.contractFiles[0].url : '',
                                    contractNote: this.form.contractNote,
                                    startDate: this.form.startDate,
                                    endDate: this.form.endDate,
                                }
                            }
                            this.$Axios._post({
                                url: this.type == 'add' ? this.$Config.apiUrl.incomeContractAdd : this.$Config.apiUrl.incomeContractUpdate,
                                method: "post",
                                params: {
                                    ...reqData
                                },
                            })
                            .then(res=>{
                                if (res.result.code == 0) {
                                    this.$message.success('操作成功')
                                    this.$emit('success');
                                    this.dialogVisible = false
                                } else {
                                    this.$message.error(res.result.message)
                                }
                            })
                            .catch(err=>{

                            })
                        }).catch(_=>{ })
                    }
                })
                
            },
        }
    }
</script>

<style lang="scss" scoped>
    .tableTitle{
        font-size: 14px;
        color: #333333;
        font-weight: 700;
        margin: 24px 0;
        display: block;
    }
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
</style>